<template>
  <div>
    <b-row class="py-3 daily-stats">
      <b-col class="d-none d-md-block"></b-col>
      <b-col md="2" cols="3" class="px-0">
        <b-img class="pb-2" src="https://storage.googleapis.com/payoo-vendor-images/orders_to_prepare.png"></b-img>
        <p>{{ orders_to_prep }}<br/>ORDERS TO PREPARE</p>
      </b-col>
      <b-col class="d-none d-md-block" md="1"></b-col>
      <b-col md="2" cols="3" class="px-0">
        <b-img class="pb-2" src="https://storage.googleapis.com/payoo-vendor-images/gross_sales.png"></b-img>
        <p>{{ total_order_amount | toCurrency }}<br/>GROSS SALES</p>
      </b-col>
      <b-col class="d-none d-md-block" md="1"></b-col>
      <b-col md="2" cols="3" class="px-0">
        <b-img class="pb-2" src="https://storage.googleapis.com/payoo-vendor-images/sales_count.png"></b-img>
        <p>{{ total_orders }}<br/>SALES COUNT</p>
      </b-col>
      <b-col class="d-none d-md-block" md="1"></b-col>
      <b-col md="2" cols="3" class="px-0">
        <b-img class="pb-2" src="https://storage.googleapis.com/payoo-vendor-images/average_ticket.png"></b-img>
        <p>{{ avg_order_amount | toCurrency }}<br/>AVERAGE SALE</p>
      </b-col>
      <b-col class="d-none d-sm-block"></b-col>
    </b-row>
  </div>
</template>


<script>
export default {
  name: "DailyStatsDash",
  data() {
    return {
      total_orders: 0,
      total_order_amount: 0,
      avg_order_amount: 0,
      orders_to_prep: 0,
      showoverlay: false,
    };
  },
  methods: {
    // emitPeriodChange() {
    //   this.$emit('emit-titem-period', this.selectedperiod);
    // },

    async fetchDailyStats() {
      this.showoverlay = true;
      const today = new Date();
      const todaysdate = today.toISOString().slice(0,10);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("reports/order-details?date=eq:"+todaysdate, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.total_orders = data.total_orders;
      this.total_order_amount = data.total_order_amount;
      this.avg_order_amount = data.avg_order_amount;
      this.orders_to_prep = await this.fetchCurrentOrders();
      this.showoverlay = false;
    },

    async fetchCurrentOrders() {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("dashboard/orders-to-prepare", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      return data.orders_to_prep[0];
    },

  },
  created() {
    this.fetchDailyStats();
  }

};
</script>
<style>

  .daily-stats {
    text-align: center;
  }

  @media (min-width: 375px) {
    .daily-stats img{
      width: 4rem;
    }

    .daily-stats p {
      font-size: 115%;
    }
  }

  .daily-stats.col-3 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .daily-stats img{
    width: 3.5rem;
  }






</style>
